import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";

import api from "../../../../../services/api";

import FrameworkTShirt from "./FrameworkTShirt";
import FrameworkNNL from "./FrameworkNNL";
import { MdOutlineFullscreenExit } from "react-icons/md";
import FrameworkBudget from "./FrameworkBudget";
import FrameworkByModule from "./FrameworkByModule";
import FrameworkTShirt2 from "./FrameworkTShirt2";

const AVAILABLE_TABS = [
  {
    id: "nnl",
    label: "Now, Next, Later",
    description: "Prioritize feature development by focusing on tasks in the Now, Next, and Later stages.",
  },
  {
    id: "tshirt",
    label: "T-Shirt",
    description: "Estimate feature complexity and effort for better resource planning and decision-making.",
  },
  {
    id: "budget",
    label: "Budget",
    description: "Track costs, planned budget based on epics and features.",
  },
  {
    id: "by_module",
    label: "By Module",
    description: "Clarify the roadmap by sorting features by module.",
  },
  {
    id: "tshirt2",
    label: "T-Shirt 2",
    description: "Estimate feature complexity and effort for better resource planning and decision-making.",
  },
];

const getTabLabel = (project, tabId) => {
  const tabInfo = AVAILABLE_TABS.find((t) => t.id === tabId);
  if (!tabInfo) return tabId;

  if (tabId === "tshirt2" && project.name === "Stipulio") {
    return "Laurent";
  }

  return tabInfo.label;
};

const Roadmap = ({ project, setProject, onSwitchBacklog }) => {
  const [tab, setTab] = useState("nnl");

  useEffect(() => {
    if (project.roadmap_tabs?.length) {
      setTab(project.roadmap_tabs[0]);
    }
  }, []);

  return (
    <div className="space-y-1 overflow-y-auto min-h-full">
      <nav className="flex items-center justify-between border-b border-gray-300">
        <div className="flex items-center">
          {project.roadmap_tabs?.map((roadmap_tab, index) => {
            const title = getTabLabel(project, roadmap_tab);
            return <TabItem key={index} tab={roadmap_tab} setTab={setTab} activeTab={tab} title={title} />;
          })}
          <RoadmapMenu project={project} setProject={setProject} />
        </div>
        <div className="flex items-center gap-2">
          <button className="text-gray-700 hover:bg-gray-100 rounded-md p-1" onClick={onSwitchBacklog} title={"Collapse Roadmap"}>
            <MdOutlineFullscreenExit className="w-5 h-5" />
          </button>
        </div>
      </nav>

      {tab === "nnl" && <FrameworkNNL project={project} setProject={setProject} />}
      {tab === "tshirt" && <FrameworkTShirt project={project} />}
      {tab === "budget" && <FrameworkBudget project={project} />}
      {tab === "by_module" && <FrameworkByModule project={project} />}
      {tab === "tshirt2" && <FrameworkTShirt2 project={project} />}
    </div>
  );
};

const RoadmapMenu = ({ project, setProject }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleCheckboxChange = async (tab, checked) => {
    const updatedTabs = checked ? [...(project.roadmap_tabs || []), tab] : (project.roadmap_tabs || []).filter((t) => t !== tab);
    await api.put(`/project/${project._id}`, {
      roadmap_tabs: updatedTabs,
    });
    setProject({ ...project, roadmap_tabs: updatedTabs });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const menu = document.getElementById("roadmap-menu");
      if (menu && !menu.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" id="roadmap-menu">
      <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="py-1 text-sm hover:bg-gray-100 rounded-t-lg flex items-center gap-2 shadow-sm transition-colors duration-200">
        <FiChevronDown className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${isMenuOpen ? "rotate-180" : ""}`} />
      </button>

      {isMenuOpen && (
        <div className="absolute -right-48 mt-2 w-96 bg-white rounded-xl shadow-lg border border-gray-100 z-30 overflow-hidden">
          <div className="p-2">
            {AVAILABLE_TABS.map((tab) => (
              <div key={tab.id} className="p-2 hover:bg-gray-50 rounded-lg transition-colors duration-150">
                <label className="flex items-start space-x-3 cursor-pointer">
                  <div className="flex-shrink-0 mt-0.5">
                    <input
                      type="checkbox"
                      checked={project.roadmap_tabs?.includes(tab.id)}
                      onChange={(e) => handleCheckboxChange(tab.id, e.target.checked)}
                      className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 h-4 w-4 transition duration-150"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center space-x-2">
                      <span className="text-sm font-medium text-gray-900">{getTabLabel(project, tab.id)}</span>
                    </div>
                    <p className="text-xs text-gray-500 mt-1 leading-relaxed">{tab.description}</p>
                  </div>
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const TabItem = ({ tab, setTab, activeTab, title, index }) => {
  const { id } = useParams();
  return (
    <button
      key={index}
      onClick={() => setTab(tab)}
      className={`text-sm px-4 py-1 hover:bg-gray-100 transition-colors border-b-2 ${activeTab === tab ? "border-sky-700 text-sky-700" : "border-transparent text-gray-500"}`}>
      {title}
    </button>
  );
};

export default Roadmap;
